export const settingRoutes = [
  {
    path: '/setting/user',
    component: () => import('@/views/modules/setting/user/user'),
    meta: { name: '用户管理', keepAlive: true, permission: 'user:view' ,modal:'系统'}
  },
  {
    path: '/setting/role',
    component: () => import('@/views/modules/setting/role/role'),
    meta: { name: '角色管理', keepAlive: true, permission: 'role:view',modal:'系统' }
  },
  {
    path: '/setting/erp-package',
    component: () => import('@/views/modules/setting/erp-package/erp-package'),
    meta: { name: '产品套餐', keepAlive: true ,modal:'系统'}
  },
  {
    path: '/setting/recharge-record',
    component: () => import('@/views/modules/setting/recharge-record/recharge-record'),
    meta: { name: '充值记录', keepAlive: true, permission: 'payRecord:view' ,modal:'系统'}
  },
  {
    path: '/setting/argument',
    component: () => import('@/views/modules/setting/argument/argument'),
    meta: { name: '参数设置', keepAlive: true ,modal:'系统'}
  },
];
